import cn from 'classnames';
import { useIntl } from "react-intl";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import MuiDrawer from "@material-ui/core/Drawer";
import Close from "assets/images/Close";

/* Styles */
import styles from 'styles/drawer.module.scss';

/* Analytics */
import { trackEvent } from 'lib/analytics';

export default function Drawer({ handleDrawerClose, open, signOut }) {

  const intl = useIntl();

  const handleMenuItemClick = (page) => () => {
    const eventName = `I_MENU_${page}`;
    trackEvent(eventName);
    handleDrawerClose();
  }

  const handleSignOut = () => {
    const eventName = 'I_MENU_SIGNOUT';
    trackEvent(eventName);
    handleDrawerClose();
    signOut();
  }

  return (
    <MuiDrawer
      className={styles.menuDrawer}
      variant="persistent"
      anchor="right"
      open={open}
      classes={{
        paper: styles.menuDrawerPaper
      }}
    >
      <div>
        <IconButton
          onClick={handleDrawerClose}
          classes={{
            root: styles.menuDrawerCloseContainer
          }}
          title={intl.formatMessage({id: 'layout.menuDrawerCloseTitle'})}
        >
          <Close className={styles.menuDrawerClose} />
        </IconButton>
      </div>
      <List>
        <ListItem>
          <a className={styles.menuDrawerLink} href="https://www.backtoworkri.com/" target="_blank" rel="noopener noreferrer" onClick={handleMenuItemClick('HOME')}>
            <span className={styles.menuDrawerLink__text}>
              {intl.formatMessage({id: 'layout.menu.home'})}
            </span>&nbsp;<img src="/images/external-link-alt-solid.svg" width="14" height="13" />
          </a>
        </ListItem>
        <ListItem>
          <a className={styles.menuDrawerLink} href="https://www.backtoworkri.com/jobs" target="_blank" rel="noopener noreferrer" onClick={handleMenuItemClick('HOME')}>
            <span className={styles.menuDrawerLink__text}>
              {intl.formatMessage({id: 'layout.menu.jobs'})}
            </span>&nbsp;<img src="/images/external-link-alt-solid.svg" width="14" height="13" />
          </a>
        </ListItem>
        <ListItem>
          <a className={styles.menuDrawerLink} href="https://www.backtoworkri.com/training" target="_blank" rel="noopener noreferrer" onClick={handleMenuItemClick('HOME')}>
            <span className={styles.menuDrawerLink__text}>
              {intl.formatMessage({id: 'layout.menu.training'})}
            </span>&nbsp;<img src="/images/external-link-alt-solid.svg" width="14" height="13" />
          </a>
        </ListItem>
        <ListItem>
          <span className={styles.menuDrawerLink} onClick={handleSignOut}>
            <span className={cn(styles.menuDrawerLink__text, styles.menuDrawerLink__text__link)}>
              {intl.formatMessage({id: 'layout.menu.signOut'})}
            </span>
          </span>
        </ListItem>
      </List>
    </MuiDrawer>
  );
}